var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramDark = function SvgInstagramDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 85"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Circle Black"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    className: "Instagram_dark_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 23c6.35 0 7.11 0 9.62.14a12.9 12.9 0 0 1 4.42.82 7.9 7.9 0 0 1 4.51 4.51 12.9 12.9 0 0 1 .82 4.42c.12 2.51.14 3.27.14 9.62s0 7.11-.14 9.62a12.9 12.9 0 0 1-.82 4.42 7.9 7.9 0 0 1-4.51 4.51 12.9 12.9 0 0 1-4.42.82c-2.51.12-3.26.14-9.62.14s-7.11 0-9.62-.14a12.9 12.9 0 0 1-4.42-.82A7.9 7.9 0 0 1 24 56.54a12.9 12.9 0 0 1-.82-4.42C23 49.61 23 48.85 23 42.5s0-7.11.14-9.62a12.9 12.9 0 0 1 .86-4.42A7.9 7.9 0 0 1 28.46 24a12.9 12.9 0 0 1 4.42-.82C35.39 23 36.15 23 42.5 23m0-4.29c-6.46 0-7.27 0-9.81.14A17.5 17.5 0 0 0 26.91 20a12.1 12.1 0 0 0-7 7 17.5 17.5 0 0 0-1.11 5.78c-.11 2.54-.14 3.35-.14 9.81s0 7.27.14 9.81a17.5 17.5 0 0 0 1.2 5.69 12.1 12.1 0 0 0 7 7 17.5 17.5 0 0 0 5.78 1.11c2.54.11 3.35.14 9.81.14s7.27 0 9.81-.14a17.5 17.5 0 0 0 5.78-1.11 12.1 12.1 0 0 0 7-7 17.5 17.5 0 0 0 1.11-5.78c.11-2.54.14-3.35.14-9.81s0-7.27-.14-9.81a17.5 17.5 0 0 0-1.11-5.78 12.1 12.1 0 0 0-7-7 17.5 17.5 0 0 0-5.78-1.11c-2.54-.11-3.35-.14-9.81-.14Z",
    className: "Instagram_dark_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 30.28A12.22 12.22 0 1 0 54.72 42.5 12.22 12.22 0 0 0 42.5 30.28m0 20.15a7.93 7.93 0 1 1 7.93-7.93 7.93 7.93 0 0 1-7.93 7.93",
    className: "Instagram_dark_svg__cls-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.2,
    cy: 29.8,
    r: 2.86,
    className: "Instagram_dark_svg__cls-2"
  }))));
};
export default SvgInstagramDark;